import React from 'react'
import styled from 'styled-components'
import { Row, Col } from '../UI'
import animation from './animation'
import { GREY, GREY_DARKER } from './colors'

const Container = styled('div')``

const Loader = styled('div')`
  animation: ${animation};
  background-color: ${GREY};
  border-radius: 8px;
  height: 20px;
  max-width: ${props => props.width};
  width: 100%;
`

const StyledHeader = styled('div')`
  background-color: #fbfbfd;
  & ${Loader} {
    background-color: ${GREY_DARKER};
  }
  border-radius: 8px;
`

const StyledRow = styled(Row)`
  align-items: center;
  border-top: ${props => props.theme.cube.border};
  height: ${props => (props.isBody ? '55px' : '50px')};
  padding: 0 10px;
`

const StyledCol = styled(Col)`
  flex-grow: unset;
`

const LineSkeleton = props => {
  return (
    <Container {...props}>
      <StyledHeader>
        <StyledRow gutter={30}>
          <StyledCol span={20}>
            <Loader />
          </StyledCol>
          <StyledCol span={10}>
            <Loader />
          </StyledCol>
        </StyledRow>
      </StyledHeader>
    </Container>
  )
}

LineSkeleton.propTypes = {
}

LineSkeleton.defaultProps = {
}

export default LineSkeleton
